


document.addEventListener('DOMContentLoaded', function() {
    let currentStep = 0;
    const steps = document.querySelectorAll('.step');
    const nextButtons = document.querySelectorAll('.btn_next');
    const formControls = document.querySelectorAll('.form_control');
    const radioButtons = document.querySelectorAll('input[type="radio"]');
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    const backButton = document.querySelector('.step_back');
    const crampsRadios = document.querySelectorAll('input[name^="menstrual_cramps"]');
    let score = 65;  // Start with the base score of 65
    let selectedCrampsIntensity = 0; // Variable to store the user's selected intensity level


  
    function calculateScore() {
        // Reset score to the base value
        score = 65;
    
        // Step 1: Pain Medication
        const painMedication = document.querySelector('input[name="pills"]:checked');
        if (painMedication) {
            if (painMedication.value === 'always') score += 12;
            else if (painMedication.value === 'sometimes') score += 10;
            else if (painMedication.value === 'hardly') score += 4;
        }
    
        // Step 3: Diagnosis Details
        const adenomyosisSelected = document.querySelector('input[name="diagnosis"][value="adenomyosis"]:checked');
        if (adenomyosisSelected) {
            score += 20;  // Significant bump for Adenomyosis
        }
    
        // Step 5: Menstrual Cramps Intensity
        if (selectedCrampsIntensity) {
            score += selectedCrampsIntensity * 3; // Adjusted for intensity 3
        }

    
        // Step 6: Period Length
        const periodLength = document.querySelector('input[name="period"]:checked');
        if (periodLength) {
            if (periodLength.value === '7+') score += 10;
            else if (periodLength.value === '5-7') score += 7;
            else if (periodLength.value === '3-5') score += 4;
            else if (periodLength.value === '1-3') score += 2;
        }
    
        // Step 8: Number of Childbirths
        const childbirths = document.querySelector('input[name="childbirths"]:checked');
        if (childbirths && childbirths.value === 'yes') {
            const childbirthCount = document.querySelector('input[name="childbirths_count"]:checked');  // Assuming another radio group for childbirth count
            if (childbirthCount) {
                if (childbirthCount.value === '3+') score -= 8; // More childbirths lower the score
                else if (childbirthCount.value === '2') score -= 5;
                else if (childbirthCount.value === '1') score -= 3;
            }
        } else {
            score += 2; // No childbirths, add points
        }
    
        // Step 9: Body Type
        const bodyType = document.querySelector('input[name="body_type"]:checked');
        if (bodyType) {
            if (bodyType.value === 'banana') score += 5;
            else if (bodyType.value === 'apple') score += 4;
            else if (bodyType.value === 'pear') score += 2;
        }
    
        // Ensure score is within the desired range
        score = Math.max(65, Math.min(98, score));
    
        // Update the result text with the calculated score
        const resultText = `You have a ${score}% match for Livia. Livia will eliminate your period pains in seconds.`;
        const resultElement = document.querySelector('#step10 .form_title.second_font_theme.text_center span');
        if (resultElement) {
            resultElement.textContent = resultText;
        }
        console.log("Final Score: ", score);  // Debug log to check the final score
    }

    // Function to show a specific step
    function showStep(index, direction = 'forward') {
       // If it's the final step, calculate the score
        if (index === 10) {  
            calculateScore();
            const lastButton = steps[index].querySelector('.btn_next');
            lastButton.disabled = false;  // Enable the last button
            lastButton.addEventListener('click', function() {
                window.location.href = 'https://mylivia.com/products/livia';  // Redirect to the URL
            });
        }
      
        // Remove active and animation classes from all steps
        steps.forEach((step, idx) => {
            step.classList.remove('active', 'slide-in-left', 'slide-in-right', 'slide-out-left', 'slide-out-right');
            if (idx === currentStep) {
                step.classList.add(direction === 'forward' ? 'slide-out-left' : 'slide-out-right');
            }
        });

        // Hide the previous step after the transition
        setTimeout(() => {
            steps[currentStep].style.display = 'none';

            // Show the new step
            steps[index].style.display = 'block';
            steps[index].classList.add('active', direction === 'forward' ? 'slide-in-right' : 'slide-in-left');

            // Update the current step index
            currentStep = index;

            // Handle back button visibility
            backButton.style.display = currentStep === 0 ? 'none' : 'block';
        }, 500); // The duration should match the CSS transition timing
    }

    // Function to check if the form fields are filled (for Step 0)
    function checkFormValidity() {
        const step = steps[currentStep];
        const inputs = step.querySelectorAll('.form_control');
        let allFilled = true;
        inputs.forEach(input => {
            if (input.value.trim() === '') {
                allFilled = false;
            }
        });
        const nextButton = step.querySelector('.btn_next');
        nextButton.disabled = !allFilled;
    }

    // Function to check if any radio button or checkbox is selected
    function checkRadioValidity() {
        const step = steps[currentStep];
        const radios = step.querySelectorAll('input[type="radio"], input[type="checkbox"]');
        let oneChecked = false;
        radios.forEach(radio => {
            if (radio.checked) {
                oneChecked = true;
            }
        });
        const nextButton = step.querySelector('.btn_next');
        nextButton.disabled = !oneChecked;
    }

    // Handle menstrual cramps selection
    function handleCrampsSelection(level) {
        const step = steps[currentStep];
        const nextButton = step.querySelector('.btn_next'); 

        // Store the actual intensity the user selected
        selectedCrampsIntensity = level;

      
        // Loop through all the cramps radios
        crampsRadios.forEach(radio => {
            // Check all the radios with value less than or equal to the selected level
            if (parseInt(radio.value) <= level) {
                radio.checked = true;
            } else {
                // Uncheck the radios with value greater than the selected level
                radio.checked = false;
            }
        });

        nextButton.disabled = false; // Enable the Continue button
        calculateScore();
    }

    // Add event listeners to each radio button for menstrual cramps
    crampsRadios.forEach(radio => {
        radio.addEventListener('click', function() {
            handleCrampsSelection(parseInt(this.value));
        });
    });

    // Add input event listeners to form controls
    formControls.forEach(input => {
        input.addEventListener('input', checkFormValidity);
    });

    // Add change event listeners to radio buttons and checkboxes
    radioButtons.forEach(radio => {
        radio.addEventListener('change', checkRadioValidity);
    });
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', checkRadioValidity);
    });
  

    // Add click event listeners to next buttons
    nextButtons.forEach(btn => {
        btn.addEventListener('click', function(event) {
            event.preventDefault();
        
            if (!btn.disabled) { // Only proceed if the button is enabled
                if (currentStep < steps.length - 1) {
                    // Handle specific logic for steps
                    if (currentStep === 0) { // Step 0: Name entry
                        const firstName = document.getElementById('first_name').value.trim();
                        localStorage.setItem('firstName', firstName);
                        document.getElementById('user_first_name').innerText = firstName;
                        showStep(currentStep + 1);
                    } else if (currentStep === 2) { // Step 2: Any Diagnosis
                        const diagnosisSelection = document.querySelector('input[name="any_diagnosis"]:checked');
                        if (diagnosisSelection && diagnosisSelection.value === 'no') {
                            showStep(5); // Skip to "Menstrual Cramps" if "No"
                        } else {
                            showStep(currentStep + 1); // Otherwise, proceed to next step
                        }
                    } else if (currentStep === 3) { // Step 3: Diagnosis Details
                        const pacemakerImplantSelected = document.querySelector('input[name="diagnosis"][value="pacemaker_implant"]:checked');
                        if (pacemakerImplantSelected) {
                            showStep(4); // Jump to "Sorry" page if "Pacemaker implant"
                        } else {
                            showStep(5); // Otherwise, proceed to "Menstrual Cramps"
                        }
                    } else if (currentStep === 7) { // Step 7: Any Childbirths
                        const childbirthSelection = document.querySelector('input[name="childbirths"]:checked');
                        if (childbirthSelection && childbirthSelection.value === 'yes') {
                            showStep(8); // Show "How many childbirths" step if "Yes"
                        } else {
                            showStep(9); // Otherwise, skip to "Body Type"
                        }
                    } else {
                        showStep(currentStep + 1); // Proceed to next step in all other cases
                    }
                }
            }
        });
    });

    backButton.addEventListener('click', function(event) {
        event.preventDefault();
    
        if (currentStep > 0) {
            if (currentStep === 5 && document.querySelector('input[name="any_diagnosis"]:checked').value === 'no') {
                showStep(2, 'backward'); // Go back to the diagnosis step
            } else if (currentStep === 5) {
                showStep(3, 'backward'); // Go back to the diagnosis details step
            } else if (currentStep === 8) { // Step 8: Go back to step 7 if it was skipped
                showStep(7, 'backward');
            } else if (currentStep === 9) { // Step 9: Body Type, back to step 7 or 8
                const childbirthSelection = document.querySelector('input[name="childbirths"]:checked');
                if (childbirthSelection && childbirthSelection.value === 'yes') {
                    showStep(8, 'backward');
                } else {
                    showStep(7, 'backward');
                }
            } else {
                showStep(currentStep - 1, 'backward');
            }
            calculateScore();  // Recalculate the score whenever going back
        }
    });


    // Add event listeners to recalculate score when selections change
    document.querySelectorAll('input[name="pills"], input[name="diagnosis"],  input[name="period"], input[name="childbirths"], input[name="childbirths_count"], input[name="body_type"]').forEach(input => {
        input.addEventListener('change', calculateScore);
    });
  
    // Initial step display and validation
    steps[currentStep].style.display = 'block'; // Ensure the first step is visible
    checkFormValidity();
    checkRadioValidity();
  

});
